import { Component, Input, ViewEncapsulation } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { EntityTypeEnum } from 'src/app/core/enums/entity-type-id-enum';
import { ButtonIdEnum } from 'src/app/core/enums/list-layout/button-id-enum';
import { ButtonTypeEnum } from 'src/app/core/enums/list-layout/button-type-enum';
import { BlogsBaseModel } from 'src/app/core/models/blogs/blogs-base.model';
import { UserBaseModel } from 'src/app/core/models/members/user/user-base.model';
import { NgSelectListModel } from 'src/app/core/models/ng-select-list.model';
import { SecurityOperations } from 'src/app/core/security/security-operations';
import { AiApiService } from 'src/app/core/services/ai-api.service';
import { AuthMyfileService } from 'src/app/core/services/auth.myfile.service';
import { DefaultImageService } from 'src/app/core/services/default-image.service';
import { BlogListService } from 'src/app/core/services/list-services/blog-list.service';
import { BlogModalService } from 'src/app/core/services/modal-services/create-blog-modal.service';
import { MyfileApiService} from 'src/app/core/services/myfile-api.service';
import { GlobalComponent } from 'src/app/global-component';
import { FileManagementListTableConfig } from 'src/app/shared/list-views/file-management/configs/table-file-management-list.config';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-blog-page-view',
  templateUrl: './blog-page-view.component.html',
  styleUrls: ['./blog-page-view.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class BlogPageViewComponent {

  protected profileImageURL: string | SafeResourceUrl = GlobalComponent.defaultUserImage;
  
  protected defaultImageService: DefaultImageService = new DefaultImageService();
  
  attachmentsConfig = new FileManagementListTableConfig();

  breadCrumbItems!: Array<{}>;

  hasBlogUpdate = this.authService.canAccessOperation(SecurityOperations.blog.blogUpdate);

  noBlogFound: boolean = true;

  ownerId = this.authService.currentUserContextValue?.id;

  entityTypeId = EntityTypeEnum.Blog;

  @Input() public model: BlogsBaseModel = new BlogsBaseModel;

  constructor(
    protected blogListService: BlogListService,
    protected blogModalService: BlogModalService,
    protected url: ActivatedRoute,
    protected aiApiService: AiApiService,
    protected myfileApiService: MyfileApiService,
    protected authService: AuthMyfileService,
    protected sanitizer: DomSanitizer,
  ) {
  }

  ngOnInit(): void {

    this.breadCrumbItems = [
      { label: 'Insights' },
      { label: 'View', active: true }
    ];
    this.profileImageURL = this.defaultImageService.getDefaultUserImage(this.model.createdBy?.fullName);
    if (this.model.id === undefined) {
      this.url.queryParams.subscribe(params => {
        this.model.id = params['id'];
        if (this.model.id !== undefined) {
          this.aiApiService.getBlog(this.model.id).subscribe(model => {
            if (typeof model !== 'boolean') {
              this.model = model;
              this.noBlogFound = false;
              this.loadProfilePhoto(this.model.createdBy?.id, this.model.createdBy?.profilePhotoFileId);
            }
          })
        }
      })
    } else {
      this.noBlogFound = false;
    }

    this.attachmentsConfig.buttons = [
      {
        visible: this.authService.canAccessOperation(SecurityOperations.file.fileCreate),
        label: "Download Selected",
        iconIsAfterLabel: false,
        action: ButtonIdEnum.Download,
        color: "btn-primary",
        icon: "ri-download-2-line",
        type: ButtonTypeEnum.CheckBoxSelected,
      }];
  }

  getDocumentImageUrl(imageUrl: any) {
    if (imageUrl) {
      var filename = imageUrl.split('/').pop();

      if (filename.includes("120.png")) {
        filename = "myfile_border.jpg";
      }

      return environment.staticImageApiUrl + filename;
    }
    else {
      return GlobalComponent.defaultDocumentImageUrl;
    }
  }

  editModal() {
    this.blogModalService.openModal(this.model);
  }

  isPublished(published: boolean | undefined) {
    if (published === true) {
      return `Published`
    }
    return `Not Published`
  }

  loadProfilePhoto(modelId: string | undefined, profilePhotoFileId: string | undefined) {
    if (modelId && profilePhotoFileId) {
      this.myfileApiService.getEntityFile(EntityTypeEnum.User, modelId, profilePhotoFileId).subscribe(result => {
        if (result) {
          var reader = new FileReader();
          reader.readAsDataURL(result);
          reader.onload = () => {
            if (reader.result) {
              this.profileImageURL = this.sanitizer.bypassSecurityTrustResourceUrl(`data:image/png;base64, ${reader.result.toString().split(',')[1]}`);
            }
          }
        }
      });
    }
  }
}
